import { z as zod } from 'zod';

// The server omits null fields from the JSON, so optional/absent fields use `.nullish()`
// (accepts the value, `null`, or a missing key). `recipientUserId` is the int user id (a number on the wire).
export const NotificationPayloadSchema = zod.object({
  body: zod.string(),
  createdDate: zod.string(),
  entityId: zod.number().nullish(),
  entityType: zod.enum(['mailing', 'mailinglist', 'recipient']).nullish(),
  id: zod.number(),
  outcome: zod.enum(['running', 'completed', 'failed', 'cancelled', 'timedout', 'info']),
  processRequestId: zod.number().nullish(),
  readDate: zod.string().nullish(),
  recipientUserId: zod.number(),
  sourceCode: zod.string().nullish(),
  title: zod.string(),
  updatedDate: zod.string(),
});
